export const productKeys = {
  basicWind: 'basic_wind',
  freeTrial: 'mindful_membership_credit',
  nationalSolar: 'national_solar',
  sponsoredMembership: 'sponsored_membership_credit',
};
